import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=31d823eb&scoped=true&"
import script from "./Currency.vue?vue&type=script&lang=js&"
export * from "./Currency.vue?vue&type=script&lang=js&"
import style0 from "./Currency.vue?vue&type=style&index=0&id=31d823eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d823eb",
  null
  
)

export default component.exports